export const permissionStructure = {
  dashboard: {
    label: "Dashboards",
    resources: {
      dashboard: ["view"]
    }
  },

  subadmin: {
    label: "Manage Sub Admin Users",
    resources: {
      subadmin: ["view", "create", "edit", "delete"]
    }
  },

  master: {
    label: "Manage Master",
    resources: {
      display_name: ["view", "create", "edit", "delete"],
      certificate: ["view", "create", "edit", "delete"],
      brand: ["view", "create", "edit", "delete"],
      category: ["view", "create", "edit", "delete"],
      subcategory: ["view", "create", "edit", "delete"],
      subsubcategory: ["view", "create", "edit", "delete"],
      role: ["view", "create", "edit", "delete"],
      features: ["view", "create", "edit", "delete"]
    }
  },

  media: {
    label: "Media Gallery",
    resources: {
      media: ["view", "create","edit", "delete"]
    }
  },

  products: {
    label: "Manage Products",
    resources: {
      products: ["view", "create", "edit", "delete"]
    }
  },

  inward: {
    label: "Manage Inward",
    resources: {
      online_store: ["view", "create", "edit"],
      offline_warehouse: ["view", "create", "edit"]
    }
  },

  customers: {
    label: "Manage Customers",
    resources: {
      individual: ["view", "edit", "delete"],
      corporate: ["view", "edit", "delete"]
    }
  },

  carts: {
    label: "Manage Carts",
    resources: {
      individual_customers: ["view", "edit"],
      corporate_customers: ["view", "edit"]
    }
  },

  requests: {
    label: "Manage Requests",
    resources: {
      bom: ["view", "edit"],
      product_requests: ["view", "edit"],
      contact_request: ["view", "delete"]
    }
  },

  tickets: {
    label: "Manage Ticket",
    resources: {
      tickets: ["view", "reply", "close"]
    }
  },

  contents: {
    label: "Manage Contents",
    resources: {
      blogs: ["view", "create", "edit", "delete"],
      banner: ["view", "create", "edit", "delete"],
      legal: ["view", "edit"]
    }
  },

  orders: {
    label: "Manage Orders",
    resources: {
      corporate: ["view", "edit"],
      corporate_invoice: ["view", "edit", "create"],
      corporate_outward: ["view", "edit", "create"],
      individual: ["view", "edit"],
      individual_invoice: ["view", "edit", "create"],
      individual_outward: ["view", "edit", "create"],
    }
  },

  reports: {
    label: "Generate Reports",
    resources: {
      reports: ["view", "export"]
    }
  },

  shipping: {
    label: "Shipping Charge",
    resources: {
      shipping: ["view", "edit"]
    }
  },

  settings: {
    label: "Settings",
    resources: {
      settings: ["edit"]
    }
  }
};